<template>
  <div class="row mt-4" v-if="paisesEur.length || paisesUsd.length">

    <!-- EUR -->
    <div class="col-lg-6 mb-4" v-if="paisesEur.length">
      <div class="card ficha-listado h-100">
        <div class="px-4 pb-4 card-body">
          <div class="d-flex align-items-center gap-2 mb-3">
            <h6 class="mb-0 panel-section-title">Top países compradores</h6>
            <span class="moneda-badge eur">EUR €</span>
            <span class="total-ventas-badge">{{ totalVentasEur }} ventas · {{ fmtEur(totalImporteEur) }} <span class="badge-nota">(solo ventas nuevas, no incluye renovaciones)</span></span>
          </div>
          <div class="table-responsive">
            <table class="table table-flush table-empirulada">
              <thead class="thead-light">
                <tr>
                  <th class="th-sort" @click="sortBy('eur','pais')">País <span class="si">{{ icon('eur','pais') }}</span></th>
                  <th class="th-sort text-center" @click="sortBy('eur','ventas_eur')">Ventas <span class="si">{{ icon('eur','ventas_eur') }}</span></th>
                  <th class="th-sort text-end col-imp" @click="sortBy('eur','importe_eur')">Montos € <span class="si">{{ icon('eur','importe_eur') }}</span></th>
                </tr>
              </thead>
              <tbody class="text-sm">
                <tr v-for="r in sortedEur" :key="r.pais + '-eur'">
                  <td>
                    <div class="d-flex align-items-center gap-2">
                      <span :class="flagClass(r.pais)" style="font-size:18px"></span>
                      <span>{{ paisNombre(r.pais) }}</span>
                    </div>
                  </td>
                  <td class="text-center"><b>{{ r.ventas_eur }}</b></td>
                  <td class="text-end col-imp">{{ fmtEur(r.importe_eur) }}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>

    <!-- USD -->
    <div class="col-lg-6 mb-4" v-if="paisesUsd.length">
      <div class="card ficha-listado h-100">
        <div class="px-4 pb-4 card-body">
          <div class="d-flex align-items-center gap-2 mb-3">
            <h6 class="mb-0 panel-section-title">Top países compradores</h6>
            <span class="moneda-badge usd">USD $</span>
            <span class="total-ventas-badge">{{ totalVentasUsd }} ventas · {{ fmtUsd(totalImporteUsd) }} <span class="badge-nota">(solo ventas nuevas, no incluye renovaciones)</span></span>
          </div>
          <div class="table-responsive">
            <table class="table table-flush table-empirulada">
              <thead class="thead-light">
                <tr>
                  <th class="th-sort" @click="sortBy('usd','pais')">País <span class="si">{{ icon('usd','pais') }}</span></th>
                  <th class="th-sort text-center" @click="sortBy('usd','ventas_usd')">Ventas <span class="si">{{ icon('usd','ventas_usd') }}</span></th>
                  <th class="th-sort text-end col-imp" @click="sortBy('usd','importe_usd')">Montos $ <span class="si">{{ icon('usd','importe_usd') }}</span></th>
                </tr>
              </thead>
              <tbody class="text-sm">
                <tr v-for="r in sortedUsd" :key="r.pais + '-usd'">
                  <td>
                    <div class="d-flex align-items-center gap-2">
                      <span :class="flagClass(r.pais)" style="font-size:18px"></span>
                      <span>{{ paisNombre(r.pais) }}</span>
                    </div>
                  </td>
                  <td class="text-center"><b>{{ r.ventas_usd }}</b></td>
                  <td class="text-end col-imp">{{ fmtUsd(r.importe_usd) }}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
const NOMBRES_PAISES = {
  AD:'Andorra', AE:'Emiratos Árabes', AF:'Afganistán', AL:'Albania', AM:'Armenia',
  AO:'Angola', AR:'Argentina', AT:'Austria', AU:'Australia', AZ:'Azerbaiyán',
  BA:'Bosnia y Herzegovina', BB:'Barbados', BD:'Bangladés', BE:'Bélgica',
  BF:'Burkina Faso', BG:'Bulgaria', BH:'Baréin', BI:'Burundi', BJ:'Benín',
  BN:'Brunéi', BO:'Bolivia', BR:'Brasil', BS:'Bahamas', BT:'Bután',
  BW:'Botsuana', BY:'Bielorrusia', BZ:'Belice', CA:'Canadá', CD:'R. D. del Congo',
  CF:'Rep. Centroafricana', CG:'Congo', CH:'Suiza', CI:'Costa de Marfil',
  CL:'Chile', CM:'Camerún', CN:'China', CO:'Colombia', CR:'Costa Rica',
  CU:'Cuba', CV:'Cabo Verde', CY:'Chipre', CZ:'Chequia', DE:'Alemania',
  DJ:'Yibuti', DK:'Dinamarca', DM:'Dominica', DO:'Rep. Dominicana',
  DZ:'Argelia', EC:'Ecuador', EE:'Estonia', EG:'Egipto', ER:'Eritrea',
  ES:'España', ET:'Etiopía', FI:'Finlandia', FJ:'Fiyi', FR:'Francia',
  GA:'Gabón', GB:'Reino Unido', GD:'Granada', GE:'Georgia', GH:'Ghana',
  GM:'Gambia', GN:'Guinea', GQ:'Guinea Ecuatorial', GR:'Grecia',
  GT:'Guatemala', GW:'Guinea-Bisáu', GY:'Guyana', HN:'Honduras',
  HR:'Croacia', HT:'Haití', HU:'Hungría', ID:'Indonesia', IE:'Irlanda',
  IL:'Israel', IN:'India', IQ:'Irak', IR:'Irán', IS:'Islandia', IT:'Italia',
  JM:'Jamaica', JO:'Jordania', JP:'Japón', KE:'Kenia', KG:'Kirguistán',
  KH:'Camboya', KM:'Comoras', KP:'Corea del Norte', KR:'Corea del Sur',
  KW:'Kuwait', KZ:'Kazajistán', LA:'Laos', LB:'Líbano', LC:'Santa Lucía',
  LI:'Liechtenstein', LK:'Sri Lanka', LR:'Liberia', LS:'Lesoto',
  LT:'Lituania', LU:'Luxemburgo', LV:'Letonia', LY:'Libia', MA:'Marruecos',
  MC:'Mónaco', MD:'Moldavia', ME:'Montenegro', MG:'Madagascar',
  MK:'Macedonia del Norte', ML:'Malí', MM:'Myanmar', MN:'Mongolia',
  MR:'Mauritania', MT:'Malta', MU:'Mauricio', MV:'Maldivas', MW:'Malaui',
  MX:'México', MY:'Malasia', MZ:'Mozambique', NA:'Namibia', NE:'Níger',
  NG:'Nigeria', NI:'Nicaragua', NL:'Países Bajos', NO:'Noruega', NP:'Nepal',
  NZ:'Nueva Zelanda', OM:'Omán', PA:'Panamá', PE:'Perú', PH:'Filipinas',
  PK:'Pakistán', PL:'Polonia', PT:'Portugal', PY:'Paraguay', QA:'Catar',
  RO:'Rumania', RS:'Serbia', RU:'Rusia', RW:'Ruanda', SA:'Arabia Saudita',
  SC:'Seychelles', SD:'Sudán', SE:'Suecia', SG:'Singapur', SI:'Eslovenia',
  SK:'Eslovaquia', SL:'Sierra Leona', SM:'San Marino', SN:'Senegal',
  SO:'Somalia', SR:'Surinam', SS:'Sudán del Sur', SV:'El Salvador',
  SY:'Siria', SZ:'Suazilandia', TD:'Chad', TG:'Togo', TH:'Tailandia',
  TJ:'Tayikistán', TL:'Timor Oriental', TM:'Turkmenistán', TN:'Túnez',
  TO:'Tonga', TR:'Turquía', TT:'Trinidad y Tobago', TZ:'Tanzania',
  UA:'Ucrania', UG:'Uganda', US:'Estados Unidos', UY:'Uruguay',
  UZ:'Uzbekistán', VC:'San Vicente y las Granadinas', VE:'Venezuela',
  VN:'Vietnam', VU:'Vanuatu', WS:'Samoa', YE:'Yemen',
  ZA:'Sudáfrica', ZM:'Zambia', ZW:'Zimbabue',
};

export default {
  name: "PanelTipsterPaises",
  props: {
    paisesVentas:  { type: Array, default: () => [] },
    paisesImporte: { type: Array, default: () => [] },
    kpis:          { type: Object, default: () => ({}) },
  },
  data() {
    return {
      sorts: {
        eur: { col: 'ventas_eur', dir: 'desc' },
        usd: { col: 'ventas_usd', dir: 'desc' },
      },
    };
  },
  computed: {
    allPaises() {
      // Fusiona ambas fuentes eliminando duplicados por país
      const map = new Map();
      for (const r of [...this.paisesVentas, ...this.paisesImporte]) {
        const key = r.pais;
        if (!map.has(key)) {
          map.set(key, { ...r });
        } else {
          const ex = map.get(key);
          ex.ventas_eur  = Math.max(ex.ventas_eur || 0, r.ventas_eur || 0);
          ex.ventas_usd  = Math.max(ex.ventas_usd || 0, r.ventas_usd || 0);
          ex.importe_eur = Math.max(ex.importe_eur || 0, r.importe_eur || 0);
          ex.importe_usd = Math.max(ex.importe_usd || 0, r.importe_usd || 0);
        }
      }
      return Array.from(map.values());
    },
    paisesEur() { return this.allPaises.filter(r => (r.importe_eur || 0) > 0); },
    paisesUsd() { return this.allPaises.filter(r => (r.importe_usd || 0) > 0); },
    sortedEur() { return this._sort(this.paisesEur, this.sorts.eur); },
    sortedUsd() { return this._sort(this.paisesUsd, this.sorts.usd); },
    totalVentasEur()  { return this.paisesEur.reduce((s, r) => s + (r.ventas_eur  || 0), 0); },
    totalVentasUsd()  { return this.paisesUsd.reduce((s, r) => s + (r.ventas_usd  || 0), 0); },
    totalImporteEur() { return this.paisesEur.reduce((s, r) => s + (r.importe_eur || 0), 0); },
    totalImporteUsd() { return this.paisesUsd.reduce((s, r) => s + (r.importe_usd || 0), 0); },
  },
  methods: {
    _sort(arr, s) {
      if (!s.col) return arr;
      const dir = s.dir === 'asc' ? 1 : -1;
      return [...arr].sort((a, b) => {
        let va = s.col === 'pais' ? this.paisNombre(a.pais).toLowerCase() : (a[s.col] ?? 0);
        let vb = s.col === 'pais' ? this.paisNombre(b.pais).toLowerCase() : (b[s.col] ?? 0);
        if (va < vb) return -dir; if (va > vb) return dir; return 0;
      });
    },
    sortBy(grupo, col) {
      const s = this.sorts[grupo];
      if (s.col === col) { this.sorts[grupo] = { col, dir: s.dir === 'asc' ? 'desc' : 'asc' }; }
      else { this.sorts[grupo] = { col, dir: col === 'pais' ? 'asc' : 'desc' }; }
    },
    icon(grupo, col) {
      const s = this.sorts[grupo];
      return s.col !== col ? '↕' : s.dir === 'asc' ? '↑' : '↓';
    },
    flagClass(code) {
      const cc = String(code || '').trim().toLowerCase();
      return /^[a-z]{2}$/.test(cc) ? `fi fi-${cc}` : '';
    },
    paisNombre(code) {
      return NOMBRES_PAISES[String(code || '').trim().toUpperCase()] || code;
    },
    fmtEur(n) {
      return Number(n || 0).toLocaleString('es-ES', { style: 'currency', currency: 'EUR', maximumFractionDigits: 0 });
    },
    fmtUsd(n) {
      return Number(n || 0).toLocaleString('en-US', { style: 'currency', currency: 'USD', maximumFractionDigits: 0 });
    },
  },
};
</script>

<style scoped>
.th-sort { cursor: pointer; user-select: none; white-space: nowrap; }
.th-sort:hover { color: var(--q-gold); }
.si { font-size: 0.7rem; opacity: 0.55; margin-left: 2px; }
.th-sort:hover .si { opacity: 1; color: var(--q-gold); }
.col-imp { min-width: 90px; }

.paises-subtitulo { margin-bottom: 10px; }
.moneda-badge {
  display: inline-block;
  font-size: 11px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: .6px;
  padding: 2px 10px;
  border-radius: 6px;
}
.moneda-badge.eur { background: rgba(99,102,241,.15); color: #818cf8; border: 1px solid rgba(99,102,241,.3); }
.moneda-badge.usd { background: rgba(16,185,129,.15); color: #34d399; border: 1px solid rgba(16,185,129,.3); }
.total-ventas-badge { font-size: 12px; color: var(--q-muted, rgba(231,237,245,.5)); font-variant-numeric: tabular-nums; }
.badge-nota { font-size: 10px; opacity: .6; }

.table-empirulada { border-collapse: separate !important; border-spacing: 0 8px; }
.table-empirulada thead th { border: 0 !important; background: var(--q-hover); color: var(--q-text); font-weight: 700; padding: 10px 12px; }
.table-empirulada tbody tr { background: var(--q-card-alt); box-shadow: 0 4px 12px rgba(0,0,0,.05); }
.table-empirulada tbody td { border: 0 !important; padding: 10px 12px; vertical-align: middle; }
.table-empirulada > :not(caption) > * > * { border-bottom-width: 0 !important; }
.table-empirulada tbody tr:hover { transform: translateY(-1px); transition: .15s ease; }
.table-empirulada tbody tr td:first-child { border-top-left-radius: 10px; border-bottom-left-radius: 10px; }
.table-empirulada tbody tr td:last-child { border-top-right-radius: 10px; border-bottom-right-radius: 10px; }
.table-empirulada thead, .table-empirulada thead tr, .table-empirulada thead th { border-radius: 0 !important; }
.table-empirulada thead th:first-child, .table-empirulada thead th:last-child { border-radius: 0 !important; }
.table-empirulada thead tr { box-shadow: none !important; background: transparent !important; }
</style>
